// material-ui
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

// project imports
import LogoSection from '../LogoSection';
// import SearchSection from './SearchSection';
import MobileSection from './MobileSection';
import ProfileSection from './ProfileSection';
// import LocalizationSection from './LocalizationSection';
import MegaMenuSection from './MegaMenuSection';
// import FullScreenSection from './FullScreenSection';
import NotificationSection from './NotificationSection';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { MenuOrientation, ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';

// assets
import { IconMenu2 } from '@tabler/icons-react';
import ContactSupportSection from './ContactSupportSection';
import OnboardingSetupHeaderCue from './OnboardingSetupHeaderCue';
import OpsConsoleHeaderLink from './OpsConsoleHeaderLink';
import SystemGlobalBanner from './SystemGlobalBanner';
import ImpersonationBanner from './ImpersonationBanner';
import AccountBlockedBanner from './AccountBlockedBanner';
import TemplatesPendingBadge from './TemplatesPendingBadge';
import { isNative } from 'platform/native';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

export default function Header() {
  const theme = useTheme();
  const downMD = useMediaQuery(theme.breakpoints.down('md'));

  const { mode, menuOrientation } = useConfig();
  const { menuMaster } = useGetMenuMaster();
  const drawerOpen = menuMaster.isDashboardDrawerOpened;
  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downMD;

  return (
    <>
      {/* logo & toggler button */}
      <Box sx={{ width: downMD ? 'auto' : 228, display: 'flex', alignItems: 'center', pt: 0, pb: 0 }}>
        {!isHorizontal && (
          <Avatar
            variant="rounded"
            sx={{
              mr: 1,
              ml: -1,
              ...theme.typography.commonAvatar,
              ...theme.typography.mediumAvatar,
              overflow: 'hidden',
              transition: 'all .2s ease-in-out',
              bgcolor: mode === ThemeMode.DARK ? 'dark.main' : 'secondary.light',
              color: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
              '&:hover': {
                bgcolor: mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.dark',
                color: mode === ThemeMode.DARK ? 'secondary.light' : 'secondary.light',
              },
            }}
            onClick={() => handlerDrawerOpen(!drawerOpen)}
            color="inherit"
          >
            <IconMenu2 stroke={1.5} size="20px" />
          </Avatar>
        )}

        <Box sx={{ flexGrow: 1 }} />

        <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
          <LogoSection />
        </Box>
      </Box>

      {/* header search */}
      {/* <SearchSection /> */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: { xs: 'none', md: 'flex' },
          justifyContent: 'center',
          alignItems: 'center',
          px: 1,
          overflow: 'hidden',
        }}
      >
        <SystemGlobalBanner />
        <AccountBlockedBanner />
        <ImpersonationBanner />
      </Box>

      {/* mega-menu */}
      {/* <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <MegaMenuSection />
      </Box> */}

      {/* live customization & localization */}
      {/* <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
        <LocalizationSection />
      </Box> */}

      {/* notification + mega-menu (desktop): spacing between bell and grid icons */}
      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ ml: 2 }}>
        {!isNative && <OnboardingSetupHeaderCue />}
        {!isNative && <OpsConsoleHeaderLink />}
        <NotificationSection />
        {!isNative && <TemplatesPendingBadge />}
        {!isHorizontal && (
          <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
            <MegaMenuSection />
          </Box>
        )}
      </Stack>

      {/* full sceen toggler */}
      {/* <Box sx={{ display: { xs: 'none', lg: 'block' } }}>
        <FullScreenSection />
      </Box> */}

      {/* Contact support dialog */}
      <Box sx={{ display: { xs: 'none', md: 'block' } }}>
        <ContactSupportSection />
      </Box>

      {/* MegaMenu for mobile - next to settings icon (באפליקציה: רווח מהפעמון) */}
      <Box sx={{ display: { xs: 'block', md: 'none' }, ...(isNative && { marginInline: 1.5 }) }}>
        <MegaMenuSection />
      </Box>

      {/* באפליקציה הפרופיל נדחף לקצה הנגדי של הכותרת */}
      {isNative && <Box sx={{ flexGrow: 1 }} />}

      {/* profile */}
      <ProfileSection />

      {/* mobile header */}
      {!isNative && (
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <MobileSection />
        </Box>
      )}
    </>
  );
}
